document.addEventListener('DOMContentLoaded', function() {
  const originalElements = document.querySelectorAll('.enabled__split-media');

  originalElements.forEach(function(originalEle) {
    originalEle.addEventListener('mouseenter', function() {
      const newEle = originalEle.nextElementSibling;
      if (newEle && newEle.classList.contains('split__media-wrapper')) {
        newEle.style.display = 'grid';
        originalEle.style.display = 'none';
      }
    });
  });
});

